import React, {Component} from "react";
import axios from "axios";
import moment from "moment";
import {Button} from "reactstrap";
import Cookies from "js-cookie";
import {Helmet} from "react-helmet";
import Modal from "./MiModal";

const SERVICE_STATUS_OUT = process.env.REACT_APP_SERVICE_STATUS_OUT;
const SERVICE_QUEUE_OUT = process.env.REACT_APP_SERVICE_QUEUE_OUT;
const SERVICE_QUEUE_IN = process.env.REACT_APP_SERVICE_QUEUE_IN;
const SERVICE_MAIL = process.env.REACT_APP_SERVICE_CONFIG_SEND_MAIL;
const SERVICE_RETURN_URL = process.env.REACT_APP_SERVICE_CONFIG_RETURN_URL;
const SERVICE_MAIL_DATA = process.env.REACT_APP_SERVICE_CONFIG_MAIL_DATA;
const MENSAJE_ERROR_ENVIO_MAIL = "Ha ocurrido un error al enviar el Mail";

export default class Queue extends Component {
  state = {
    loadedStyles: false,
    queueInfo: null,
    redirectAmount: 0,
    estimatedDate: 0,
    emailSent: false,
    mensajeError: "",
    modalOpen: true,
  };

  onRequestClose = () => {
    this.setState({ modalOpen: false });
    this.salirCola();
  };

  onConfirm = () => {
    this.setState({ modalOpen: false });
  };
  componentDidMount() {
    const systemName = this.props.match.params.systemName;
    const queueName = this.props.match.params.queueName;
    this.queueCheck();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    this.setState({ modalOpen: true });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    // Limpiar el timeout si el componente se desmonta
    if (this.loadStylesTimeout) {
      clearTimeout(this.loadStylesTimeout);
    }
  }

  handleBeforeUnload = (event) => {
    this.setState({ modalOpen: false });
    if (
        !this.state.emailSent &&
        this.state.redirectAmount === 0 &&
        event.clientY < 0
    ) {
      event.preventDefault();
      this.salirCola();
      return (event.returnValue = "");
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.queueInfo !== this.state.queueInfo && this.state.queueInfo && !this.state.loadedStyles) {
      // Usar setTimeout para retrasar la actualización de loadedStyles
      this.loadStylesTimeout = setTimeout(() => {
        this.setState({ loadedStyles: true });
      }, 1500); // 1 segundo y medio de retraso
    }
  }

  render() {
    const { queueInfo, estimatedDate, emailSent, mensajeError ,  loadedStyles, modalOpen} = this.state;

    const endpointMail = SERVICE_MAIL;

    let body;
    let mail;
    let importCss;
    let importJs;

    if (queueInfo == null) {
      body = <p>Obteniendo información del usuario...</p>;
    } else {
      if (emailSent) {
        mail = <p>Mail enviado correctamente</p>;
      } else {
        mail = (
            <div id="mail-panel">
              <p id="comming" className="txt-label">
                {queueInfo.redirect ? "Vas a ser redireccionado a la página" : ""}
              </p>

              <div className="form-group">
                <input
                    className="form-input"
                    type="text"
                    ref={(input) => (this.userEmail = input)}
                    placeholder="Correo electrónico"
                />
                <Button onClick={this.handleSendMail} className="btn">
                  Enviar link de acceso
                </Button>
              </div>
              <p id="mensajeError">{mensajeError}</p>
              <div className="form-group">
                <Button onClick={this.handleSalirCola} className="btn">
                  Abandonar la fila
                </Button>
              </div>
            </div>
        );
      }

      body = (
          <div>
            <div className="info-panel">
              <div className="info-panel-item">
                <p className="number-queue">
                <span className="info-panel-number">
                  {queueInfo.numberOnQueue}
                </span>
                </p>
              </div>
              <div className="info-panel-item">
                <p id="time-waiting">
                  {this.timeWaitingrPrefixMessage(queueInfo.waitSeconds)}
                  <span className="info-panel-number">
                  {this.timeWaiting(queueInfo.waitSeconds)}{" "}
                </span>
                  {this.timeWaitingMessage(queueInfo.waitSeconds)}
                </p>
              </div>
              <div id="date-waiting" className="info-panel-item">
                <p>Hora estimada de acceso: {estimatedDate}</p>
              </div>
            </div>

            {mail}

            <input
                type="hidden"
                ref={(input) => (this.endpointMail = input)}
                value={endpointMail}
            />
          </div>
      );

      importCss = queueInfo.cssFiles && (
          <Helmet>
            {queueInfo.cssFiles.map((endpointCSS, index) => (
                <link
                    key={index}
                    rel="stylesheet"
                    type="text/css"
                    href={endpointCSS}
                />
            ))}
          </Helmet>
      );

      importJs = queueInfo.jsFiles && (
          <Helmet>
            {queueInfo.jsFiles.map((scriptURL, index) => (
                <script key={index} src={scriptURL} type="text/javascript" />
            ))}
          </Helmet>
      );
    }

    return (
        <div>
          {importCss}
          {importJs}

          {this.state.loadedStyles ? (
              <div>
                <header className="site-header">
                  <div className="logo" />
                </header>

                <main className="site-main">
                  <div className="site-content">
                    <figure className="site-figure">
                      <div className="loading" />
                    </figure>

                    {body}

                    <p id="dataRefresh" className="small-txt">
                      Última actualización: {moment().format("hh:mm:ss a")}
                    </p>
                  </div>
                </main>
              </div>
          ) : (
              <div id="loaderWrapper">
                <div className="loader" />
              </div>
          )}
          {loadedStyles && modalOpen && ( // Muestra el modal solo si modalOpen es true
              <Modal
                  isOpen={modalOpen}
                  onRequestClose={this.onRequestClose}
                  onConfirm={this.onConfirm}
              />
          )}
        </div>
    );
  }

  salirCola = () => {
    const queueName = this.props.match.params.queueName;
    const systemName = this.props.match.params.systemName;

    this.state.redirectAmount++;
    axios
        .get(
            SERVICE_STATUS_OUT +
            "/system/" +
            systemName +
            "/status/out/" +
            queueName,
            {
              withCredentials: true,
              headers: {
                isQueueOut: "true",
                usersession: Cookies.get("vqueue_session_id"),
                timeonqueue: Cookies.get("vqueue_waiting_" + queueName),
              },
            }
        )
        .then((result) => {
          axios
              .get(SERVICE_RETURN_URL + systemName)
              .then((result) => {
                window.location.href = result.data;
              })
              .catch((error) => console.error("Error on return url", error));
        })
        .catch((error) => console.error("Error on status out", error));
  };

  queueCheck = () => {
    const queueName = this.props.match.params.queueName;
    const systemName = this.props.match.params.systemName;

    this.vqCookies = {
      usrSession: Cookies.get("vqueue_session_id"),
    };

    axios
        .get(
            SERVICE_QUEUE_OUT + "/system/" + systemName + "/queue/" + queueName,
            { withCredentials: true }
        )
        .then((result) => {
          let redirectAmount = result.data.redirect
              ? this.state.redirectAmount + 1
              : 0;
          this.setState({
            queueInfo: result.data,
            redirectAmount: redirectAmount,
            estimatedDate: moment()
                .add(result.data.waitSeconds * result.data.numberOnQueue, "seconds")
                .format("hh:mm:ss a"),
          });

          if (redirectAmount >= 1) {
            window.location.href = result.data.redirectURL;
          } else {
            setTimeout(this.queueCheck, result.data.refresh);
          }
        })
        .catch((error) => console.error("Error on queue out", error));
  };

  handleSendMail = async () => {
    Cookies.set("vqueue_session_id", this.vqCookies.usrSession, { path: "/" });

    const queueName = this.props.match.params.queueName;
    const systemName = this.props.match.params.systemName;
    const userSessionCookie = Cookies.get("vqueue_session_id");

    const mailDTO = await this.obtenerMailData();

    const emailPayload = {
      queueInDomain: SERVICE_QUEUE_IN,
      emailTo: this.userEmail.value,
      systemName: systemName,
      queueName: queueName,
      userSessionCookie: userSessionCookie,
      mailDTO: mailDTO
    };

    axios
        .post(SERVICE_MAIL, emailPayload)
        .then((response) => {
          if (response.data === true) {
            this.setState({
              emailSent: true,
            });
          } else {
            this.setState({
              emailSent: false,
              mensajeError: MENSAJE_ERROR_ENVIO_MAIL,
            });

            setTimeout(
                function () {
                  this.setState({
                    mensajeError: "",
                  });
                }.bind(this),
                5000
            );
          }
        })
        .catch((error) => {
          console.log(">>> Ha ocurrido un error: " + error);
          this.setState({
            emailSent: false,
            mensajeError: MENSAJE_ERROR_ENVIO_MAIL,
          });

          setTimeout(
              function () {
                this.setState({
                  mensajeError: "",
                });
              }.bind(this),
              5000
          );
        });
  };

  obtenerMailData = async () => {
    try {
      const response = await axios.get(SERVICE_MAIL_DATA + this.props.match.params.systemName);
      return response.data;
    } catch (error) {
      console.error("Error al obtener mail data:", error);
      throw error;
    }
  };

  handleSalirCola = () => {
    if (
        window.confirm("¿Desea realmente salir de la cola y perder el lugar?")
    ) {
      this.salirCola();
    }
  };

  timeWaiting(value) {
    let minutes = Math.floor(value / 60);
    if (minutes >= 120) {
      return 2;
    }
    if (minutes >= 60 && minutes < 120) {
      return 1;
    }
    return minutes;
  }

  timeWaitingMessage(value) {
    let minutes = Math.floor(value / 60);
    if (minutes >= 60 && minutes < 120) {
      return " hora de espera.";
    }
    if (minutes >= 120) {
      return " horas de espera.";
    }
    return " minutos de espera.";
  }

  timeWaitingrPrefixMessage(value) {
    let minutes = Math.floor(value / 60);
    if (minutes >= 120) {
      return "Te quedan más de ";
    }
    if (minutes >= 60 && minutes < 120) {
      return "Te queda más de ";
    }
    return "Te quedan aproximadamente ";
  }
}
